import { GamesShell, GAMES_ACCENT } from "./GamesShell.jsx";
import { ToolCard } from "../components/ToolCard.jsx";
import { ToolGrid } from "../components/ToolGrid.jsx";
import { getFamily } from "./families.js";
import { gamesInFamily } from "./registry.js";

// V44 — generic family subgrid. A family's home page is just this
// component with a familyId prop. Each family's <Home> wrapper sets
// the prop; styling reads from FAMILIES.
//
// SEO content: each family component (MathHome.jsx, etc.) renders
// its own seoContent prop into the body. Keep family-specific content
// in those wrappers so the words live in JSX, not in the registry.
export function FamilyHome({ familyId, seoContent }) {
  const family = getFamily(familyId);
  if (!family) {
    return (
      <GamesShell title="Not found" back="/games/home">
        <p style={{ color: "#9A9DBE" }}>Unknown family.</p>
      </GamesShell>
    );
  }

  const games = gamesInFamily(familyId);

  return (
    <GamesShell title={family.name} back="/games/home">
      {/* Family description */}
      <p style={{ fontSize: 14, color: "#9A9DBE", margin: "0 0 22px", lineHeight: 1.55 }}>
        {family.description}
      </p>

      {/* Games grid — uses GAMES_ACCENT (the master rose for games suite),
          tiles still get their family-specific gradient via gradientFor */}
      <ToolGrid>
        {games.map(g => (
          <ToolCard
            key={g.id}
            accent={family.accent}
            to={g.path}
            name={g.name}
            desc={g.tagline}
          />
        ))}
      </ToolGrid>

      {/* Family SEO content — substantive narrative about what this
          family is and why these games exist */}
      {seoContent && (
        <div style={{ marginTop: 36, paddingTop: 28, borderTop: "1px solid #1C1E2E", color: "#9A9DBE", fontSize: 14.5, lineHeight: 1.7 }}>
          {seoContent}
        </div>
      )}
    </GamesShell>
  );
}
